import React from "react";
import { FlaskConical } from "lucide-react";

/** Éles oldalon: demo / teszt készlet jelölése (nem valós eladói ajánlat). */
export function TestListingBadge({ className = "", compact = false }) {
  return (
    <span
      data-testid="badge-test-listing"
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold uppercase tracking-wide bg-amber-500/95 text-anthracite-900 shadow-lg ${
        compact ? "px-2 py-0.5 text-[9px]" : "px-2.5 py-1 text-[10px]"
      } ${className}`}
    >
      <FlaskConical className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} strokeWidth={2.5} aria-hidden />
      Teszt autó
    </span>
  );
}
